import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  HomeToStoreInitialState,
  HomeToStoreSetAgenciesList,
  HomeToStoreSetAgencyError,
  HomeToStoreSetAgencyInfo,
  HomeToStoreSetAgencyLoader,
  SetHomeToStoreColisNumberAndDescriptionAction,
  SetHomeToStoreReceiverAction,
  SetHomeToStoreSenderAction,
  SetHomeToStoreSenderIsNotReceiverAction,
  SetHomeToStoreSubmitDataSetErrorAction,
  SetHomeToStoreSubmitDataSetLoaderAction,
  SetHomeToStoreSubmitDataSetSuccessAction,
} from '../HomeToStore.types';

const initialState: HomeToStoreInitialState = {
  agency: {
    isLoading: false,
    info: null,
    error: null,
    agencies: [],
  },
  submitData: {
    isLoading: false,
    error: null,
    success: null,
  },
  form: {
    sender: {
      firstName: '',
      lastName: '',
      email: '',
      tel: '',
      address: '',
    },
    receiver: {
      firstName: '',
      lastName: '',
      email: '',
      tel: '',
      address: '',
    },
    senderIsNotReceiver: false,
    toAgency: '',
    colisNumber: 0,
    description: '',
  },
  marketingAgencyId: undefined,
};

export const HomeToStoreSlicer = createSlice({
  name: 'HomeToStore',
  initialState,
  reducers: {
    setHomeToStoreAgencyLoader: (state, action: PayloadAction<HomeToStoreSetAgencyLoader>) => {
      state.agency.isLoading = action.payload.isLoading;
    },
    setHomeToStoreAgencyError: (state, action: PayloadAction<HomeToStoreSetAgencyError>) => {
      state.agency.error = action.payload.error;
    },
    setHomeToStoreAgencyInfo: (state, action: PayloadAction<HomeToStoreSetAgencyInfo>) => {
      state.agency.info = action.payload.info;
    },
    setHomeToStoreAgenciesList: (state, action: PayloadAction<HomeToStoreSetAgenciesList>) => {
      state.agency.agencies = action.payload.agencies;
    },
    setHomeToStoreSender: (state, action: PayloadAction<SetHomeToStoreSenderAction>) => {
      state.form.sender = action.payload.sender;
      state.form.toAgency = action.payload.sender.toAgency;
    },
    setResetHomeToStoreFormData: (state) => {
      state.form = initialState.form;
    },
    setHomeToStoreReceiver: (state, action: PayloadAction<SetHomeToStoreReceiverAction>) => {
      state.form.receiver = action.payload.receiver;
    },
    setHomeToStoreSenderIsNotReceiver: (state, action: PayloadAction<SetHomeToStoreSenderIsNotReceiverAction>) => {
      state.form.senderIsNotReceiver = action.payload.senderIsNotReceiver;
    },
    setHomeToStoreColisNumberAndDescription: (
      state,
      action: PayloadAction<SetHomeToStoreColisNumberAndDescriptionAction>,
    ) => {
      state.form.colisNumber = action.payload.colisNumber;
      state.form.description = action.payload.description;
    },
    setHomeToStoreSubmitDataSetLoader: (state, action: PayloadAction<SetHomeToStoreSubmitDataSetLoaderAction>) => {
      state.submitData.isLoading = action.payload.isLoading;
    },
    setHomeToStoreSubmitDataSetError: (state, action: PayloadAction<SetHomeToStoreSubmitDataSetErrorAction>) => {
      state.submitData.error = action.payload.error;
    },
    setHomeToStoreSubmitDataSetSuccess: (state, action: PayloadAction<SetHomeToStoreSubmitDataSetSuccessAction>) => {
      state.submitData.success = action.payload.success;
    },
    setHomeToStoreIsFromAgencyMarketing: (state, action: PayloadAction<string | undefined>) => {
      state.marketingAgencyId = action.payload;
    },
  },
});

export const {
  setHomeToStoreAgencyError,
  setHomeToStoreAgencyInfo,
  setHomeToStoreSender,
  setHomeToStoreAgencyLoader,
  setHomeToStoreAgenciesList,
  setHomeToStoreSenderIsNotReceiver,
  setHomeToStoreReceiver,
  setHomeToStoreColisNumberAndDescription,
  setHomeToStoreSubmitDataSetLoader,
  setHomeToStoreSubmitDataSetError,
  setHomeToStoreSubmitDataSetSuccess,
  setResetHomeToStoreFormData,
  setHomeToStoreIsFromAgencyMarketing,
} = HomeToStoreSlicer.actions;

export const HomeToStoreReducer = HomeToStoreSlicer.reducer;
